export const assessmentConstants = {
    PAGE_REQUEST:     'ASSESSMENT_PAGE_REQUEST',
    PAGE_SUCCESS:     'ASSESSMENT_PAGE_SUCCESS',
    PAGE_FAILURE:     'ASSESSMENT_PAGE_FAILURE'
}